import { useComponentTranslation } from '@core/i18n'
import {
  Box,
  Button,
  Flex,
  FocusLock,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
} from '@core/ui-elements'
import { eitherOrString } from '@utils/utilities'
import { useState } from 'react'
import { MdQrCode } from 'react-icons/md'

import { HiddenBarcodeInput } from '../../../hidden-barcode-input'

type IDInputProps = {
  handleSubmit: (id: string) => void
  isLoading: boolean
}

export const IDInput = ({ handleSubmit, isLoading }: IDInputProps) => {
  const [id, setId] = useState<string | null>('')
  const [isScannerDisabled, setIsScannerDisabled] = useState(false)
  const t = useComponentTranslation('SetIndentification')

  const handleInputChange = (value: string | null) => {
    setId(value)
    setIsScannerDisabled(!!value)
  }

  return (
    <Flex direction="column" height="100%" justifyContent="space-between">
      <Box flex="1">
        <HiddenBarcodeInput
          disabled={isScannerDisabled}
          handleSubmit={handleSubmit}
        />
        <Heading fontSize="0.875rem">{t('Cant scan? Type your ID')}</Heading>
        <FocusLock isDisabled={!isScannerDisabled}>
          <InputGroup marginTop="0.5rem" padding="0.0625rem">
            <InputLeftAddon>
              <Icon as={MdQrCode} fontSize="1rem" />
            </InputLeftAddon>
            <Input
              borderLeftRadius="0"
              inputMode="numeric"
              placeholder="ID"
              value={eitherOrString(id)}
              onBlur={() => setIsScannerDisabled(false)}
              onChange={(e) => handleInputChange(e.target.value)}
              onClickCapture={() => setIsScannerDisabled(true)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleSubmit(eitherOrString(id))
                  handleInputChange(null)
                  setIsScannerDisabled(false)
                }
              }}
            />
          </InputGroup>
        </FocusLock>
      </Box>

      <Flex>
        <Button
          isDisabled={!id}
          isLoading={isLoading}
          type="submit"
          width="100%"
          onClick={() => {
            handleSubmit(eitherOrString(id))
            handleInputChange(null)
            setIsScannerDisabled(false)
          }}
        >
          {t('Confirm')}
        </Button>
      </Flex>
    </Flex>
  )
}
